import { T } from "@/lib/theme";

/**
 * EMark — the monumental Erenown "E" rendered as an inline wordmark unit.
 * Bricolage Grotesque 800, warm accent, slightly tighter tracking. Used
 * inline inside meta strips, page codes, and registry headers where we
 * previously wrote "ERN".
 */
export default function EMark({ size = 12 }) {
  return (
    <span
      aria-hidden
      style={{
        fontFamily: "'Bricolage Grotesque', system-ui, sans-serif",
        fontWeight: 800,
        color: T.warm,
        letterSpacing: "-0.02em",
        lineHeight: 1,
        fontSize: size,
        textTransform: "uppercase",
        display: "inline-block",
      }}
    >
      E
    </span>
  );
}
